module.exports = __webpack_public_path__ + "img/cover.d5ac4f76.png";